import { all } from 'redux-saga/effects';

import consultationSaga from './consultationSaga';

export default function* rootSaga() {
  yield all([consultationSaga()]);
}
